import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppFooterModule,
  AppHeaderModule,
  AppSidebarModule,
} from '@coreui/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

// import { AgGridModule } from 'ag-grid-angular';
import { AppComponent } from './app.component';
// Import routing module
import { AppRoutingModule } from './app.routing';
// import { VadminModule } from './vadmin/vadmin.module';
// import { UserModule } from './user/user.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ChartsModule } from 'ng2-charts';
import { FormioModule } from 'angular-formio';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './public/login/login.component';
import { MatInputModule } from '@angular/material/input';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgModule, APP_INITIALIZER } from '@angular/core';
// DE-6 — languages are DATA (a row in vd_language), not code. The pack is fetched from the server
// before the first paint; see the APP_INITIALIZER in providers below.
import { I18nService } from './services/i18n.service';
// DE-7 — the public survey page. Outside the authed shell: it is the only screen a stranger sees.
import { PublicSurveyComponent } from './public/survey/public-survey.component';
import { ContractSignComponent } from './public/contract-sign/contract-sign.component';
import { CandidateTrackComponent } from './public/candidate-track/candidate-track.component';
import { P404Component } from './vadmin/error/404.component';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ToastrModule } from 'ngx-toastr';
import { InfiniteScrollModule } from 'ngx-infinite-scroll'; //InfiniteScroll lazy loading
import { MatSelectModule } from "@angular/material/select";
import { AgmCoreModule } from '@agm/core';
import { TabViewModule } from 'primeng/tabview';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { GoogleMapsModule } from '@angular/google-maps'
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { MatMenuModule } from "@angular/material/menu";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { UtilityModule } from "./utility/utility.module";
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmMarkerSpiderModule } from 'agm-spiderfier1';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

// Import containers
import { VadminComponent } from './vadmin/vadmin.component';
import { ClientComponent } from './client/client.component';
import { WithAuthGuard } from './guards/with-auth.guard';
import { WithoutAuthGuard } from './guards/without-auth.guard';
import { CanCompDeactivateGuard } from './guards/can-comp-deactivate.guard';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// Import ServiceWorker
import { ServiceWorkerModule } from '@angular/service-worker';
// Import firebase functions from SDK
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';

import { googleApiKey, baseUrl, socketIoConfig, firebaseConfig, firebaseVapId } from '../environments/environment';


import { UserComponent } from './user/user.component';
// The Ask AI FAB sits inside the UserComponent template, so it has to be
// declared where UserComponent is — not in user.module.ts.
import { AiFabComponent } from './user/ai-assistant/ai-fab/ai-fab.component';
import { AdminLoginComponent } from './public/admin-login/admin-login.component';
import { ClientLoginComponent } from './public/client-login/client-login.component';

import { IntroComponent } from './intro/intro.component';
import { VerdentumPrivacyMobileComponent } from './intro/verdentum-privacy-mobile/verdentum-privacy-mobile.component';
import { VerdentumPrivacyComponent } from './intro/verdentum-privacy/verdentum-privacy.component';
import { OrgPrivacyComponent } from './intro/org-privacy/org-privacy.component';
import { VideoComponent } from './intro/video/video.component';

import { InviteComponent } from './public/invite/invite.component';
import { GeneralComponent as InviteGeneralComponent } from './public/invite/general/general.component';
import { PartnerComponent as InvitePartnerComponent } from './public/invite/partner/partner.component';
import { SuccessComponent as InviteSuccessComponent } from './public/invite/success/success.component';

import { ViewdataComponent } from './public/viewdata/viewdata.component';
import { SurveyComponent as ViewSurveyComponent } from './public/viewdata/survey/survey.component';

import { ForgotPasswordComponent } from './public/login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './public/login/reset-password/reset-password.component';
import { PublicShareableDashboardComponent } from './public/public-shareable-dashboard/public-shareable-dashboard.component';
import { SharePostComponent } from './public/share-post/share-post.component';
import { RfpFormComponent } from './public/rfp-form/rfp-form.component';
import { PipComponent } from './public/pip/pip.component';
import { RfqComponent } from './public/rfq/rfq.component';
import { AfBenefProfileComponent } from './public/af-benef-profile/af-benef-profile.component';

import { MatDialogModule } from "@angular/material/dialog";
import { SignupComponent } from './public/signup/signup.component';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { BookingConfirmComponent } from './public/booking-confirm/booking-confirm.component';

// import { HighchartsChartComponent } from 'highcharts-angular';

const APP_CONTAINERS = [
  VadminComponent,
  UserComponent,
  ClientComponent,
  AiFabComponent
];

const cookieConfig:NgcCookieConsentConfig = {
  "cookie": {
    "domain": `${baseUrl}`
  },
  "position": "bottom",
  "theme": "edgeless",
  "palette": {
    "popup": {
      "background": "#000000",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#f1d600",
      "text": "#000000",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "message": "This website uses cookies to ensure you get the best experience on our website.",
    "dismiss": "Accept all",
    "deny": "Refuse cookies",
    "link": "Cookie Policy",
    "href": `${baseUrl}/#/intro/verdentum_privacy/`,
    "policy": "Cookie Policy"
  }
}




const socketConfig: SocketIoConfig = socketIoConfig;

@NgModule({
  imports: [
    BrowserModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: true,
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireMessagingModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // VadminModule,
    // UserModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    SocketIoModule.forRoot(socketConfig),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule ,
    FormioModule,
    MatInputModule,
    CKEditorModule,
    // AgGridModule.withComponents([]),
    MatDialogModule,
    TourMatMenuModule.forRoot(),
    NgcCookieConsentModule.forRoot(cookieConfig),
    InfiniteScrollModule,
    MatSelectModule,
    AgmCoreModule.forRoot({
      apiKey: googleApiKey,
      libraries: ['places']
    }),
    TabViewModule,
    ProgressbarModule,
    GoogleMapsModule,
    CarouselModule,
    MatMenuModule,
    CollapseModule.forRoot(),
    UtilityModule,
    AgmSnazzyInfoWindowModule,
    AgmJsMarkerClustererModule,
    AgmMarkerSpiderModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    LoginComponent,
    AdminLoginComponent,
    ClientLoginComponent,
    SignupComponent,
    IntroComponent,
    VerdentumPrivacyMobileComponent,
    VerdentumPrivacyComponent,
    OrgPrivacyComponent,
    VideoComponent,
    InviteComponent,
    InviteGeneralComponent,
    InvitePartnerComponent,
    InviteSuccessComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PublicShareableDashboardComponent,
    SharePostComponent,
    // HighchartsChartComponent
    RfpFormComponent,
    ViewdataComponent,
    ViewSurveyComponent,
    PipComponent,
    RfqComponent,
    AfBenefProfileComponent,
    PublicSurveyComponent,
    BookingConfirmComponent,   // DE-7 — /s/:slug, no guard: the only screen a stranger ever sees
    ContractSignComponent,   // /sign/:token, no guard: the person signing may have no account at all
    CandidateTrackComponent, // /track/:token, no guard: a candidate never has an account
  ],
  providers: [
    WithAuthGuard,
    WithoutAuthGuard,
    BsDatepickerConfig,
    CanCompDeactivateGuard,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,

    // ── DE-6: load the language pack BEFORE the app renders ───────────────────
    // APP_INITIALIZER, not ngOnInit. Without it the first paint is always English and then snaps
    // into Hindi a moment later — which is exactly the kind of flicker that makes a field worker
    // think the app is broken. The pack is a single small request and everything downstream
    // (labels, the switcher, the text direction on <html>) depends on it, so it is worth blocking
    // the first paint for.
    //
    // It never rejects: a language server that is down must not stop anyone logging in. The app
    // simply comes up in English.
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [I18nService],
      useFactory: (i18n: I18nService) => () => i18n.init().catch(() => {}),
    },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
